/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import { getPopularByView } from 'actions';
import { linkToProductDetail } from '../../../../../../util/appUtils';
import { useLocalizedMessage } from '../../../../../../util/useLocalizedMessage';
import cardStyles from '../../StoreAnalyticsCards.module.scss';
import AnalyticsMetricBar from 'app/routes/search/analytic/components/AnalyticsMetricBar';

const PopularProductsByView = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { products, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { popularByView: { isFetching, data, error } } = products;
  const rows = Array.isArray(data) ? data : [];
  const maximumViews = Math.max(1, ...rows.map((row) => Number(row.count || 0)));

  useEffect(() => {
    dispatch(getPopularByView(currentShop, timeframe));
  }, [timeframe]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      label: localizeMessage('analytics.table.productName'),
      sortKey: 'nameText',
    },
    {
      id: 'count',
      numeric: true,
      label: localizeMessage('analytics.table.views'),
      render: (value) => (
        <AnalyticsMetricBar
          value={value}
          maximum={maximumViews}
          label={localizeMessage('analytics.table.views')}
          tone="productViews"
        />
      ),
    },
  ];

  const prepareRows = (rows) => rows.map((e) => ({
    ...e,
    nameText: e.name,
    name: linkToProductDetail(currentShop, e.name, e.id),
  }));

  return (
    <CardContainer
      headerId="search.analytics.popularItemsByView.header"
      styleName={`noMargin ${cardStyles.card} ${cardStyles.views}`}
      tableSurface
      isFetching={isFetching}
      error={error}
    >
      <AnalyticTable
        rows={prepareRows(rows)}
        headCells={headCells}
        orderById="count"
        emptyMessageId="analytics.empty.popularViews"
      />
    </CardContainer>
  );
};

export default PopularProductsByView;
